import { pipe, filter, propEq, sortBy, prop, reject } from 'ramda'

const filterAndSortProducts = products => {
  const productsWithNoPosition = pipe(
    filter(propEq('Position', null)),
    sortBy(prop('NameInternal')),
  )(products)

  const productsWithPosition = pipe(
    reject(propEq('Position', null)),
    sortBy(prop('Position')),
  )(products)

  return filter(prop('Enabled'))([...productsWithPosition, ...productsWithNoPosition])
}

export default filterAndSortProducts
